/**
 * Readable components (JIS X 0208 characters reachable as an operand).
 *
 * GENERATED FILE — do not edit. Rebuild with: npm run data:build
 *
 * Derived from the Unicode Character Database (c) Unicode, Inc.
 * https://www.unicode.org/copyright.html
 */
const PACKED =
  "一丁七万丈三上下不与丑且丕世丘丙丞両並中串丶丸主丿乂乃久之乍乎乏乕乗乘乙九乞也亀了予争二于云互五井亘亙亜亞亟亠亡亢交亥亦亨享京亭亮亶人仄今介付代令以任伏伐休会位何余作佰來侖侯便保修倉備僉僕儿兀允元兄充兆先光克兌免兎兒兔入全兩兪八公六兮共兵其具典兼冀内冉冊再冏冒冓冖冠冢冥冫冬几凡処凵凶出函刀刃刄分切刈刑列別利到制則剌前劉力加助劵勃勇動務勞勤勺勾勿包匆匈匍匐匕化北匡匪匱匹区医匿區十千卆升午卉半卑卒卓南単卜卞占卦卩卯危即却卵卷卸厂厄厘原厥厭厳厶去参參又叉及友反叔取受叟口古句只召可台史右号司各合吉吊同名后吏向君吝否含吾呂呆呈呉告呑周命和咢咨咸咼品員哥唐善喜喬單嗇嚴囚回因困固国國園土在圭坐垂執堂堅堯士壬壮壯声売壹壽夂夏夐夕外多夜夢大天太夫夬夭央失夲夷夸夾奄奇奈奉奏奐契奚奠奥奧女奴如妄妥妻妾委威娚婁嬰子孔存孚孛孝孟季孤孫孰孱宀它宅守安完宏宗官定宛宜客宣室宰害家容宿寅密寉察寧審寫寸寺寿封射将將專尉尊尋小少尓尚尤尨尭就尸尹尺尼尽尾局居屈屋屎屏展属屬屯山岡島崔崩嵒巛川州工左巨巫差己巳巴巵巷巻巽巾市布希帚帛帝師帯帶常幕干平幵并幸幹幺幼幾广広庄府度座庶康庸廉廛廣廴延廷建廾弁弄弋式弓引弗弘弟弯弱張強彌彎彑当彖彗彡彦彫彭彳律従從御復微徴心必忍志忝念忽思怱恣息恵悉惟惠惡愈意愛感慮憂應戈戉戊戎成我戒戔或戚戸戻扁扇扈手才折拑拜擧支攴攵攸放故效敏敕敖敝敞敢散敦敬数數斂文斉斌斗斛斤斥斬斯新方於施旁旅族旗旡既日旦旧旨早旬旱昆昌明昏易昔昜星春昭是時晃晉普景晶暴曇曲曳更曷曹曼曽替最會月有朋服朔朝木未末本札朮朱朶朿杉束来東松析林果某柔柬査栗桀梁條棘楙楚楽榮樂樊欠次欣欲歇止正此武歩歯歳歴歹死殄殳段殷殿毀毋母毎比毛毳氏民气氣水永氾求江沓沙沛沾泉泊法泙泡波洛浦海涌淫温湯溥滕滿潘澡火灰炎為烏烝焉無焦然熊熏燕爪爭爰爲爵父爻爾爿片牙牛牟物犀犬狂狄猪猶獄玄率玉王瓜瓦甘甚甜生用甫甬田由甲申男界畏留畜畢番畫異當疋疏疑疾癶癸発登發白百皀皃皆皇皐皮皿盈益盍盡監盧目直相盾眇眉県眞真睿瞿矍矛矢矣知石示神票祭禀禁禹禺禽禾禿秀秋科秦稜稟積穴空窄窒立竒竜竟章童竹筑筮算箭節米粛粥粲糸系約累絹維縁縢縣縵缶罔署罷羅羊美羔義羲羽翁習翕翰老考者耆而耒耳耶聖聚聴聶聽聿肅肉肋肖肴胃胡胥能脊臣臧自至致臺臼臾與舌舍舎舛舜舟般艮良色芒花芳芻苗苛苟若英茲荅荒莫莽菫華萃萬著葛蒙蒿蔑蔵蕩蕭薛薜藏藝藺虍虎虐虚號虫蚤蚩蜀蜜蟲血行衍衣表衰袁袞裁襄西要覃見規覚親覺覽觀角觜解言討許諸謁谷豆豈豊豐豕豚象豪豬豸貌貍貝貞貢貫責貳貴賁賈賓賛賞賣賤質贈贊赤赦赫走足路身躬車軍載轉辛辟辰辱農迷追退送通造逢連逮遂道達遣遷邑那郎部郭郷鄭酉酋釆采里重野量金長門閏閑間閔閣閭闌阜阿陏陰隆隊隋隶隹隻雁集雇雉雋雍雜離難雨雪雲零雷需霍霜青静非面革韋韭音頁頃須預頓領頡頻頼顛風飛食養首香馬馮骨高髟鬲鬼魏魚魯鮮鳥鹵鹿麗麥麦麻黄黍黎黒黨黹黽鼓鼠鼡鼻齊齒齧龍龜龠";

export const LEGIBLE_SIZE = 1177;

let set: Set<string> | null = null;

export function getLegible(): Set<string> {
  if (!set) set = new Set([...PACKED]);
  return set;
}
